export const GEOLOCATION_PERMISSION_DENIED = 1;

export function isEmbeddedWindow(win = typeof window !== "undefined" ? window : undefined) {
  if (!win) return false;

  try {
    return win.self !== win.top;
  } catch {
    return true;
  }
}

export function formatGpsPickup(coords = {}) {
  const latitude = Number(coords.latitude).toFixed(6);
  const longitude = Number(coords.longitude).toFixed(6);
  const accuracy = Number.isFinite(coords.accuracy)
    ? ` ±${Math.round(coords.accuracy)}m`
    : "";

  return `GPS: ${latitude}, ${longitude}${accuracy}`;
}

export function resolveGeolocationErrorKey({
  error,
  embedded = false,
  secureContext = true,
  supported = true,
} = {}) {
  if (!supported) return "gpsUnavailable";
  if (!secureContext) return "gpsRequiresHttps";

  if (Number(error?.code) === GEOLOCATION_PERMISSION_DENIED) {
    return embedded ? "gpsPermissionDeniedEmbedded" : "gpsPermissionDenied";
  }

  return "gpsError";
}
